import { logManager } from '../logs'
import Session from '../models/session'

// Libraries.
import { v4 as uuidV4 } from 'uuid'
import EventEmitter from 'eventemitter3'

/**
 * Manager for Session objects.
 * Allows for creation and retrieval of session objects.
 * @method SessionManager
 */
export default function SessionManager (managers) {
  const log = logManager.getLogger('Manager', 'Session')
  // Internal variables.
  const sessions = new Map()
  const emitter = new EventEmitter()

  /**
   * Create a new Session object.
   * @method create
   * @param {Object} [config]
   * @param {Object} [config.peer] Configs for the Session's Peer object.
   * @return {Session}
   */
  function create (config = {}) {
    const session = new Session(uuidV4(), managers, config)
    session.once('session:ended', id => {
      sessions.delete(id)
      emitter.emit('session:removed', id)
    })
    sessions.set(session.id, session)
    emitter.emit('session:new', session.id)
    return session
  }

  /**
   * Retrieve an existing Session object.
   * @method get
   * @param  {String} sessionId ID of the desired Session object.
   * @return {Session}
   */
  function get (sessionId) {
    const session = sessions.get(sessionId)
    if (!session) {
      log.debug(`No session found with ID: ${sessionId}.`)
    }
    return session
  }

  /**
   * Retrieve a list of all existing Sessions.
   * @method getAll
   * @return {Array} List of Media IDs.
   */
  function getAll () {
    return Array.from(sessions.values())
  }

  function on (...args) {
    return emitter.on(...args)
  }

  function once (...args) {
    return emitter.once(...args)
  }

  function off (...args) {
    return emitter.off(...args)
  }

  /**
   * The exposed API.
   */
  return {
    create,
    get,
    getAll,
    on,
    once,
    off
  }
}
